export default __webpack_public_path__ + "static/media/corporate.a85b5055.png";